module.exports = __webpack_public_path__ + "static/Michelle-2f3512e501ae15e0f4072214ccbb0ade.png";